import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keepHtml'
})
export class KeepHtmlPipe implements PipeTransform {

    constructor() {
    }

    transform(value: string, args?: any): any {
        return value ? this.unescape(value) : '';
    }

    unescape(content: string) {
        const translateRegex = /&(nbsp|amp|quot|lt|gt);/g,
            translate = {
                'nbsp': String.fromCharCode(160),
                'amp': '&',
                'quot': '"',
                'lt': '<',
                'gt': '>'
            },
            translator = function ($0, $1) {
                return translate[$1];
            };

        return content.replace(translateRegex, translator);
    }
}
